import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Calendar } from "lucide-react";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleCountBookings } from "../../../apis/bookings";

export default function AllWidget() {
  const { site } = useContext(AuthContext);

  const { data: count } = useQuery({
    queryKey: ["allCount", site?._id],
    queryFn: () =>
      handleCountBookings({
        site: site?._id === 0 ? "" : site?._id,
        isConfirmed: "",
        isFulfilled: "",
      }),
  });

  console.log(count);
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 shadow-md border border-gray-200 rounded-md p-2 bg-blue-500 text-white">
      <div className="flex">
        <div className="flex justify-center items-center w-14 h-14 bg-blue-400 border border-blue-400">
          <Calendar size={34} />
        </div>
        <div className="flex flex-col border-l border-blue-400 pl-2 ml-2">
          <div className="uppercase">All Bookings</div>
          <div className="font-bold text-2xl">{count}</div>
        </div>
      </div>
    </div>
  );
}
